import { render, staticRenderFns } from "./DeptEdit.vue?vue&type=template&id=b0e9337c&scoped=true"
import script from "./DeptEdit.vue?vue&type=script&lang=js"
export * from "./DeptEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e9337c",
  null
  
)

export default component.exports